import { getObjectId } from '@/shared/utils/commonHelper';
import { NewCreatedActivityRemainder } from './activityRemainder.interface';
import { ActivityRemainder } from './activityRemainder.model';

export const createActivityRemainder = async (
  data: NewCreatedActivityRemainder,
) => {
  try {
    await ActivityRemainder.create(data);
  } catch (err) {
    console.log(err);
  }
};

export const deleteActivityRemainderByActivityId = async (
  activityId: string,
) => {
  try {
    await ActivityRemainder.deleteMany({ activityId: getObjectId(activityId) });
  } catch (err) {
    console.log(err, 'Error in deleting activity remainder');
  }
};
